import { c as _c } from "react/compiler-runtime";
import { ExtendedWaveParticipationRequirement } from "./CreateWaveDropsTypes";
export default function CreateWaveDropsType(t0) {
  const $ = _c(18);
  const {
    isChecked,
    type,
    onRequiredTypeChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ExtendedWaveParticipationRequirement.NONE]: "None",
      [ExtendedWaveParticipationRequirement.IMAGE]: "Image",
      [ExtendedWaveParticipationRequirement.AUDIO]: "Audio",
      [ExtendedWaveParticipationRequirement.VIDEO]: "Video"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const LABELS = t1;
  const buttonClasses = isChecked ? "tw-ring-primary-400 tw-bg-[#202B45]" : "tw-ring-iron-700 tw-bg-iron-800 hover:tw-ring-iron-600";
  const labelClasses = isChecked ? "tw-text-primary-400" : "tw-text-iron-300";
  let t2;
  if ($[1] !== onRequiredTypeChange || $[2] !== type) {
    t2 = () => onRequiredTypeChange(type);
    $[1] = onRequiredTypeChange;
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `${buttonClasses} tw-flex-1 tw-relative tw-cursor-pointer tw-rounded-lg tw-ring-1 tw-ring-inset tw-px-4 tw-py-4 tw-shadow-sm focus:tw-outline-none tw-flex tw-items-center tw-gap-x-3 tw-transition tw-duration-300 tw-ease-out`;
  let t4;
  if ($[4] !== onRequiredTypeChange || $[5] !== type) {
    t4 = () => onRequiredTypeChange(type);
    $[4] = onRequiredTypeChange;
    $[5] = type;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isChecked || $[8] !== t4) {
    t5 = <div className="tw-flex tw-h-6 tw-items-center"><input checked={isChecked} onChange={t4} type="checkbox" className="tw-form-checkbox tw-w-4 tw-h-4 sm:tw-w-5 sm:tw-h-5 tw-rounded tw-bg-iron-800 tw-border-iron-600 tw-border tw-border-solid focus:tw-ring-2 tw-ring-offset-iron-800 tw-text-primary-400 focus:tw-ring-primary-400 tw-cursor-pointer" /></div>;
    $[7] = isChecked;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = LABELS[type];
  let t7;
  if ($[10] !== labelClasses || $[11] !== t6) {
    t7 = <span className="tw-flex tw-items-center"><span className="tw-flex tw-flex-col tw-text-base tw-font-semibold"><span className={labelClasses}>{t6}</span></span></span>;
    $[10] = labelClasses;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
    t8 = <div onClick={t2} className={t3}>{t5}{t7}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}